export default __webpack_public_path__ + "static/media/Pot2.da1c6bf3.svg";